import React, { useState } from "react";
import DatePicker from "react-datepicker";
import { format } from "date-fns";

import "react-datepicker/dist/react-datepicker.css";

const DatePickerComponent = ({ value = new Date(), onChange }) => {
  return (
    <DatePicker
      selected={value}
      onChange={(date) => onChange(date)}
      className="block w-full rounded-md border border-gray-300 shadow-sm text-sm px-4 py-2.5"
      dateFormat="dd/MM/yyyy"
      showMonthDropdown
      showYearDropdown
      dropdownMode="select"
      calendarClassName="bg-white border border-gray-200 shadow-lg rounded-lg p-2"
      dayClassName={(date) =>
        format(date, "eee") === "Sun"
          ? "text-red-500" // Highlight Sundays
          : "text-gray-900"
      }
    />
  );
};

export default DatePickerComponent;
